<template>
  <div class="rich-text-editor-cointainer">
    <b-field :label="lable">
      <div>
        <div class="editor-menu" v-if="!disabled">
          <b-field>
            <p class="control">
              <b-button
                icon-left="format-bold"
                @click="toggle('toggleBold')"
                :focused="isMarkFocused('bold')"
                :disabled="disabled"
              />
            </p>
            <p class="control">
              <b-button
                icon-left="format-italic"
                @click="toggle('toggleItalic')"
                :focused="isMarkFocused('italic')"
                :disabled="disabled"
              />
            </p>
            <p class="control">
              <b-button
                icon-left="format-underline"
                @click="toggle('toggleUnderline')"
                :focused="isMarkFocused('underline')"
                :disabled="disabled"
              />
            </p>
            <p class="control">
              <b-button
                icon-left="format-strikethrough-variant"
                @click="toggle('toggleStrike')"
                :focused="isMarkFocused('strike')"
                :disabled="disabled"
              />
            </p>
          </b-field>

          <b-field v-if="headings && headings.length">
            <p class="control" v-if="headings.includes(1)">
              <b-button
                icon-left="format-header-1"
                @click="toggleHeading(1)"
                :focused="isHeadingFocused(1)"
                :disabled="disabled"
              />
            </p>
            <p class="control" v-if="headings.includes(2)">
              <b-button
                icon-left="format-header-2"
                @click="toggleHeading(2)"
                :focused="isHeadingFocused(2)"
                :disabled="disabled"
              />
            </p>
            <p class="control" v-if="headings.includes(3)">
              <b-button
                icon-left="format-header-3"
                @click="toggleHeading(3)"
                :focused="isHeadingFocused(3)"
                :disabled="disabled"
              />
            </p>
          </b-field>

          <b-field>
            <p class="control">
              <b-button
                icon-left="format-list-bulleted"
                @click="toggle('toggleBulletList')"
                :focused="isMarkFocused('bulletList')"
                :disabled="disabled"
              />
            </p>
            <p class="control">
              <b-button
                icon-left="format-list-numbered"
                @click="toggle('toggleOrderedList')"
                :focused="isMarkFocused('orderedList')"
                :disabled="disabled"
              />
            </p>
          </b-field>
        </div>

        <editor-content :editor="editor" class="editor textarea-like" />
      </div>
    </b-field>
  </div>
</template>

<script>
import { Editor, EditorContent } from '@tiptap/vue-2';
import StarterKit from '@tiptap/starter-kit';
import Underline from '@tiptap/extension-underline';

export default {
  name: 'RichTextEditor',
  props: {
    value: {
      type: String,
      default: '',
    },
    lable: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    headings: {
      type: Array,
      default: () => [1, 2, 3],
    },
  },

  watch: {
    // value(value) {
    //   const isSame = this.editor.getHTML() === value;

    //   if (isSame) {
    //     return;
    //   }

    //   this.editor.commands.setContent(value, false);
    // },

    disabled(value) {
      if (this.editor) {
        this.editor.setEditable(!value);
      }
    },
  },

  components: {
    EditorContent,
  },
  data() {
    return {
      editor: null,
    };
  },
  mounted() {
    this.editor = new Editor({
      content: this.value,
      editable: !this.disabled,
      extensions: [
        StarterKit.configure({
          heading: {
            levels: [1, 2, 3],
          },
        }),
        Underline,
      ],

      onUpdate: () => {
        this.$emit('input', this.editor.getHTML());
      },

      onBlur: () => {
        this.$emit('onBlur');
      },
    });
  },
  beforeDestroy() {
    this.editor.destroy();
  },
  methods: {
    toggle(command) {
      this.editor.chain().focus()[command]().run();
    },
    toggleHeading(level) {
      this.editor.chain().focus().toggleHeading({ level }).run();
    },

    isMarkFocused(condition) {
      if (!this.editor) return false;
      return this.editor.isActive(condition) && this.editor.isFocused;
    },
    isHeadingFocused(level) {
      if (!this.editor) return false;
      return (
        this.editor.isActive('heading', { level }) && this.editor.isFocused
      );
    },
  },
};
</script>

<style scoped lang="scss">
.editor-menu {
  display: flex;
  flex-wrap: wrap;
}

.editor-menu .field {
  display: flex;
  flex-wrap: wrap;
  margin-right: 10px;
}

::v-deep(.ProseMirror) {
  min-height: 120px;
  max-height: 400px;
  overflow-y: auto;
  resize: vertical;
  outline: none !important;
  background: #fff;
  padding: 1rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-family: inherit;
  text-align: left;

  ul {
    list-style-type: disc !important;
    padding-left: 2rem !important;
    margin-left: 1rem !important;
  }

  ol {
    list-style-type: decimal !important;
    padding-left: 2rem !important;
    margin-left: 1rem !important;
  }

  li {
    list-style: inherit !important;
    display: list-item !important;
  }

  h1 {
    font-size: 1.6rem;
  }

  h2 {
    font-size: 1.4rem;
  }

  h3 {
    font-size: 1.2rem;
  }
}

.field:not(:last-child) {
  margin-bottom: 0.2rem;
}
</style>
